import { StatusPair } from '../models/status-pair';

export class MaritalData {
  private maritalStatusList: StatusPair[] = [
    new StatusPair('Single', 'S'),
    new StatusPair('Married', 'M'),
    new StatusPair('Divorced', 'D'),
    new StatusPair('Widowed', 'W'),
    // new StatusPair('Common Law Partner', 'C')
  ];

  public getMaritalStatus(): Array<StatusPair> {
    return this.maritalStatusList;
  }
}

